/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
    const stickyAtc = document.querySelector('.sticky-add-to-cart');
    
  
    if (stickyAtc) {
      let stickyButton = stickyAtc.querySelector('.sticky-atc');
      let stickyPrice = stickyAtc.querySelector('.sticky-atc--price');
      let stickyVariantId = stickyButton.dataset.variantId;
      let productOptions = document.querySelectorAll('.product__selectors .radio__input');
      const productSubmitHolder = document.querySelector('.product__submit__holder');
      console.log('productSubmitHolder', productSubmitHolder);


      const handleOptionChange = (optionValue, optionPrice) => {
        stickyVariantId = optionValue;
        stickyPrice.textContent = optionPrice;
        console.log('optionValue', optionValue);
      }

      productOptions.forEach(option => {
        option.addEventListener('change', function() {
          let optionChecked = option.checked;
          let selectedOptionVariantId = option.dataset.optionId;
          let selectedOptionVariantPrice = option.dataset.optionPrice;
          if(optionChecked) {
            handleOptionChange(selectedOptionVariantId, selectedOptionVariantPrice);
          }
        });
      });

      console.log('stickyVariantId', stickyVariantId, stickyPrice, stickyButton);
      stickyAtc.addEventListener('click', function() {
        handleAddToCart(stickyVariantId, 1);
      });

      let handleAddToCart = (variantId, quantity) => {
        const data = {
          id: variantId,
          quantity: quantity
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(() => {
            // window.refreshCart();
        })
        .catch(error => {
            console.error(error);

        });
      }


      let handleStickyVisibility = (holder) => {
        let observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            let rect = entry.boundingClientRect;
            if (rect.bottom <= 0) {
              if(!stickyAtc.classList.contains('sticky-add-to-cart--visible')) {
                stickyAtc.classList.add('sticky-add-to-cart--visible');
              }
            } else {
              if(stickyAtc.classList.contains('sticky-add-to-cart--visible')) {
                stickyAtc.classList.remove('sticky-add-to-cart--visible');
              }
            }
          });
        }, { threshold: 0 });

        if (holder) {
          observer.observe(holder);
        }
      }
  
      handleStickyVisibility(productSubmitHolder);
    }


    // Product Grid Item Add To Cart 
    const addToCartButtons = document.querySelectorAll('.fr-add-to-cart--button');

    let collectionHandleAddToCart = (variantId, quantity) => {
      const data = {
        id: variantId,
        quantity: quantity
      };
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(() => {
          // window.refreshCart();
      })
      .catch(error => {
          console.error(error);

      });
    }

    addToCartButtons.forEach(button => {
      button.addEventListener('click', function() {
        const variantId = button.dataset.variantId;
        collectionHandleAddToCart(variantId, 1);
      });
    });

    
  });
let rechargeWidget = document.querySelector('recharge-subscription-widget');
let productPrice = document.querySelector('.product__price .product__price--regular ');

if(rechargeWidget) {
  setTimeout(() => {
    let oneTimePurchase = rechargeWidget.shadowRoot.querySelector('.rc-purchase-option.rc-selection__onetime');
    let subscriptionPurchase = rechargeWidget.shadowRoot.querySelector('.rc-purchase-option.rc-purchase-option__subscription');

    if(oneTimePurchase) {
      oneTimePurchase.addEventListener('click', function() {
        let oneTimeProductPrice = oneTimePurchase.querySelector('.rc-price');
        let oneTimeProductPriceText = [...oneTimeProductPrice.childNodes]
          .filter(node => node.nodeType === Node.TEXT_NODE)
          .map(node => node.textContent.trim())
          .join('');
          productPrice.innerText = oneTimeProductPriceText;
          console.log('oneTimePurchase', oneTimeProductPriceText);
      });
    }

    if (subscriptionPurchase) {
      let priceEl = subscriptionPurchase.querySelector('.rc-price[part="rc-purchase-option__discounted-price"]');
      priceEl.addEventListener('onchange', function() {
        console.log('subscriptionPurchase', subscriptionPurchase);
      });
      subscriptionPurchase.addEventListener('click', function () {
        // let priceEl = subscriptionPurchase.querySelector('.rc-price[part="rc-purchase-option__discounted-price"]');
        let subscriptionProductPrice = [...priceEl.childNodes]
          .filter(node => node.nodeType === Node.TEXT_NODE)
          .map(node => node.textContent.trim())
          .join('');
        console.log('subscriptionPurchase', subscriptionProductPrice);
        productPrice.innerText = subscriptionProductPrice;
      });
    }
  }, 1000);
}

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
